import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
export function selectLoginButtonTooltipCookieState(state: IApplicationState): boolean {
  return state.cookies.loginButtonTooltip;
}
